export default __webpack_public_path__ + "static/media/influencer_card2.b468f365.png";